module.exports = __webpack_public_path__ + "cloud-infrastructure.3xv1PRZj.svg";